function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from "react";
import { sendDataLayerEvent } from './../../../configuration/utils';
var AccordionRowLink = function AccordionRowLink(_ref) {
  var toggleAccordion = _ref.toggleAccordion,
    currIndex = _ref.currIndex,
    item = _ref.item,
    title = _ref.title;
  return /*#__PURE__*/React.createElement("a", {
    className: "accordion-pep-feature__title",
    tabIndex: 5,
    onKeyPress: function onKeyPress(e) {
      return e.key === 'Enter' ? toggleAccordion(currIndex) : null;
    },
    onClick: function onClick() {
      return toggleAccordion(currIndex);
    }
  }, item.image && /*#__PURE__*/React.createElement("img", {
    src: item.image.url
  }), /*#__PURE__*/React.createElement("h3", null, title, " ", item.technicalDescription ? item.technicalDescription : ''));
};
var AccordionContent = function AccordionContent(_ref2) {
  var index = _ref2.index,
    val = _ref2.val,
    isActive = _ref2.isActive;
  return /*#__PURE__*/React.createElement("div", {
    key: index,
    tabIndex: isActive ? 5 : -1
  }, val.title && /*#__PURE__*/React.createElement("p", {
    className: "accordion-pep-feature__section"
  }, val.title), /*#__PURE__*/React.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: val.description.replace(/\n/gm, '<br>')
    }
  }));
};
var AccordionComponent = function AccordionComponent(_ref3) {
  var activeOnLoad = _ref3.activeOnLoad,
    element = _ref3.element,
    elementsObj = _ref3.elementsObj,
    currIndex = _ref3.currIndex;
  var _useState = useState(activeOnLoad ? activeOnLoad : 0),
    _useState2 = _slicedToArray(_useState, 2),
    activeRow = _useState2[0],
    setActiveRow = _useState2[1];
  var toggleAccordion = function toggleAccordion(index) {
    var eventLabel = currIndex !== activeRow ? currIndex + 1 + ' open' : currIndex + 1 + ' close';
    document.querySelector('.pep-product-details') ? sendDataLayerEvent('Accordion Benefits', eventLabel) : sendDataLayerEvent('Accordion', eventLabel);
    setActiveRow(currIndex !== activeRow ? index : null);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: activeRow === currIndex ? "accordion-pep-feature active" : 'accordion-pep-feature',
    "aria-expanded": activeRow === currIndex ? "true" : 'false',
    key: currIndex
  }, elementsObj[element].map(function (val, index) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, index === 0 && /*#__PURE__*/React.createElement(AccordionRowLink, {
      title: element,
      currIndex: currIndex,
      item: val,
      toggleAccordion: toggleAccordion
    }), /*#__PURE__*/React.createElement(AccordionContent, {
      index: index,
      val: val,
      isActive: activeRow === currIndex ? 5 : -1
    }));
  }));
};
export default AccordionComponent;